import SliderInput from './SliderInput';

export * from './SliderInput';

export default SliderInput;
